enum BillingTab {
  Overview = 'Overview',
  Invoices = 'Invoices',
}

export default BillingTab;
